import { useTheme } from "@emotion/react";
import { BarTimeChart } from "./bar_time_chart";
import { getBarTimeChartOptions, applyAutoScale } from "./chart_options";

export function ForecastChart({ metering, multiDay = false }) {
  const theme = useTheme();

  if (!metering) return;
  const utctime = metering.map((el) => new Date(1000 * el.utctime));
  const forecast = metering.map((el) => el.forecast);
  const consumption = metering.map((el) => el.actual);
  const actualWithCalculations = metering.map((el) => el.actual_with_calculations);
  const nomination = metering.map((el) => el.nomination);

  const data = {
    labels: utctime,
    datasets: [
      {
        fill: false,
        label: "Nomination",
        data: nomination,
        borderWidth: 3,
        borderColor: "black",
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
      },
      {
        fill: false,
        label: "Forecast",
        data: forecast,
        borderWidth: 3,
        borderColor: "grey",
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
      },
      {
        fill: true,
        label: "Actual",
        data: consumption,
        borderWidth: 0,
        borderColor: theme.palette.actuals.main,
        backgroundColor: theme.palette.actuals.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      {
        fill: true,
        label: "Actuals with Elion",
        data: actualWithCalculations,
        borderWidth: 0,
        borderColor: theme.palette.actuals.withElion,
        backgroundColor: theme.palette.actuals.withElion,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
    ],
  };

  const options = getBarTimeChartOptions(multiDay);
  options.scales.x.stacked = false;
  options.scales.y = { stacked: false };
  applyAutoScale(options, [forecast, consumption, actualWithCalculations, nomination], "Wh");

  return <BarTimeChart data={data} options={options} />;
}
